import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const AdminRoute = () => {
    const { user, isAnonymous, loading } = useAuth()

    if (loading) {
        return null
    }

    const roles = user?.roles ?? []
    const isAdmin = roles.includes('admin') || roles.includes('super_admin')

    if (isAnonymous || !isAdmin) {
        return <Navigate to="/access-denied" />
    }

    return <Outlet />
}

export default AdminRoute
